import React from 'react';
import { useTranslation } from 'react-i18next';
import '../App.scss';

const WebsiteViewer = ({ url, onClose }) => {
  const { t } = useTranslation();

  return (
    <div className="website-viewer-overlay">
      <div className="website-viewer-container">
        <div className="website-viewer-header">
          <button onClick={onClose} className="back-button">
            {t("BACK")}
          </button>
        </div>
        <iframe
          src={url}
          title="Website Viewer"
          className="website-viewer-iframe"
          sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
        />
      </div>
    </div>
  );
};

export default WebsiteViewer; 